import { isGlobalFeatureEnabled } from "owa-feature-flags";

// Check if Proactive Drafts feature is enabled
export function isProactiveDraftEnabled(): boolean {
    // Intentionally disabled while deciding whether to deprecate the proactive drafts call.
    // We intentionally do not want users to enable the proactive drafts flights in SDF.
    return false;
}

// Task 460865: [Proactive Drafts] Deprecate proactive drafts flights
export function deprecatedIsProactiveDraftEnabled(): boolean {
    return (isGlobalFeatureEnabled("mon-copilot-proactive-drafts") ||
        isGlobalFeatureEnabled("mon-copilot-proactive-drafts-enableForAllEmails"));
}
